import React from 'react';

export type EditSalesforceConnectionDialogPromptProps = Readonly<{
  prompt: string;
}>;

export function EditSalesforceConnectionDialogPrompt(props: EditSalesforceConnectionDialogPromptProps) {
  return (
    <>
      < div className="tb-margin-bottom-wide">
        {props.prompt}
      </div >
    </>
  );
}
